module.exports = __webpack_public_path__ + "img/shopee.aad2b09c.svg";